// extracted by mini-css-extract-plugin
export default {"form":"RB11wqdi","submit":"b5DJsVi8","icon":"z8eIR7Br","input":"XJO9uvBs"};